const extend = require('extend');
const baseConfig = require('./index');

extend(true, baseConfig, {
    langs: ['ru'],
    wsgate: 'wss://ws-gate.fxclub.org/ws',
    quotes_api: 'https://quoteorg.fxclub.org',
    gaterest_api: 'https://gaterest.fxclub.org/real/restapi/quotes',
    publicPath: 'https://live-quotes.fxclub.org/'
});

module.exports = baseConfig;



// WEBPACK FOOTER //
// ./config/fxclub.org.js